<template>
  <section>
    <div class="container">
      <div>
        <div class="circleHeader">
          <h2 v-html="awards.title"></h2>
        </div>
        <p v-html="awards.content"></p>
      </div>
      <div class="img" v-if="awards.image" :style="{backgroundImage: `url(${awardsImage})`}"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'awards',
  props: ['awards'],
  computed: {
    awardsImage () {
      let image = this.awards.image.sizes.medium
      if (process.env.NODE_ENV === 'development') {
        image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content')
      }
      return image
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
  @import ../../assets/styles/colors
  @import ../../assets/styles/mixins

  section
    background: $yellow
    padding-top: 84px
    padding-bottom: 60px
    .container
      +tablet
        display: flex
      > div
        &:first-child
          flex: 1
          p
            font-size: 18px
            line-height: 1.75
            +tablet
              font-size: 22px
              line-height: 40px
              margin-top: 22px
      .img
        width: 300px
        height: 300px
        border-radius: 50%
        border: 8px solid #fff
        background: $body-background
        background-size: cover
        background-position: center center
        +until($tablet)
          margin-top: 30px
        +tablet
          margin-left: 40px
          position: relative
          top: -20px
          width: 320px
          height: 320px
</style>



// WEBPACK FOOTER //
// Awards.vue?99c72d06